export default __webpack_public_path__ + "static/media/actionsIcon.8e010aa8.svg";